import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router";
import './SitemapPage.css';
import Hero from '../../components/Hero/Hero';
import Footer from '../../components/Footer/Footer';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';

const Sitemap: React.FC = () => {
  const { t } = useTranslation();

  const links = [
    { url: '/', title: 'Home' },
    { url: '/patagonia/', title: 'Patagonia' },
    { url: '/atacama/', title: 'Atacama' },
    { url: '/santa-catarina/', title: 'Santa Catarina' },
    { url: '/mendoza/', title: 'Mendoza' },
    { url: '/iguazu/', title: 'Iguazu' },
    { url: '/our-story/', title: t('navigation:ourStory') },
    { url: '/re-energize/', title: t('navigation:reEnergize') },
    { url: '/packages/', title: t('navigation:offers') },
    { url: '/gallery/', title: t('navigation:gallery') },
    { url: '/blog/', title: t('navigation:blog') },
    { url: '/contact/', title: t('navigation:contact') },
  ];

  return (
    <div className="sitemap-page">

      <title>{t('meta:sitemap.title')}</title>
      <meta name="description" content={t('meta:sitemap.description')} />
      <meta property="og:title" content={t('meta:sitemap.title')} />
      <meta property="og:description" content={t('meta:sitemap.description')} />

      <UnifiedNavigation />

      <Hero
        backgroundImage='/assets/0ff98a07ecf9bc9fd57bbcadbed10673f1a0a50f.png'
        heading="Sitemap"
      />

      <div className="sitemap__content">
        <ul className="sitemap__link-list">
          {links.map((link, index) => (
            <li key={index} className="sitemap__link-item">
              <Link className="sitemap__link" to={link.url}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <InstagramSection />

      <Footer variant="default" />
    </div>
  );
};

export default Sitemap;